import { Client } from '@stomp/stompjs'
import { BASE_URL, WS_TYPE } from '@/config/constant'
import { store } from '@/config/router'

let stompClient: Client | null = null
let num: number = 0
let timer: any = null
const pollTime: number = 5 // 重连时间 s

// 连接服务
export default function SxSocket() {
	return new Promise<Client>((resolve, reject) => {
		try {
			// 复用前先关掉残留的旧连接，避免出现多个连接互相顶掉
			if (stompClient) {
				try {
					stompClient.deactivate()
				} catch (e) { }
			}

			// 创建新的 STOMP 客户端
			stompClient = new Client({
				brokerURL: `${WS_TYPE}://${BASE_URL}/ws`,
				connectHeaders: {
					login: 'admin',
					passcode: 'qwer1234'
				},
				debug: () => { }, // 关闭调试日志
				heartbeatIncoming: 0, // 不强制要求服务端心跳
				heartbeatOutgoing: 10000, // 客户端主动发心跳维持连接
				reconnectDelay: 0 // 禁用自动重连，我们自己实现重连逻辑
			})

			if (timer) clearInterval(timer)

			// 连接成功回调
			stompClient.onConnect = (frame) => {
				console.log('服务已连接')
				num = 0
				// 连接成功后清掉残留的重连定时器
				if (timer) {
					clearInterval(timer)
					timer = null
				}
				resolve(stompClient!)
			}

			// 连接错误回调
			stompClient.onStompError = (frame) => {
				console.log('订阅失败：', frame)
			}

			// 连接断开回调
			stompClient.onDisconnect = () => {
				console.log('连接已断开')
				if (!timer) {
					timer = setInterval(() => {
						num++
						console.log(`连接服务器失败${pollTime}s后尝试重连,尝试连接${num}次........`)
						store.dispatch('subscribeData')
					}, pollTime * 1000)
				}
			}

			// WebSocket 连接错误
			stompClient.onWebSocketError = (error) => {
				console.error('WebSocket 错误:', error)
				if (!timer) {
					timer = setInterval(() => {
						num++
						console.log(`连接服务器失败${pollTime}s后尝试重连,尝试连接${num}次........`)
						store.dispatch('subscribeData')
					}, pollTime * 1000)
				}
				reject(error)
			}

			// 激活连接
			stompClient.activate()

		} catch (error) {
			console.error('连接出错:', error)
			reject(error)
		}
	}).catch(error => { console.log(error) })
}

// 断开 socket 连接
export function disconnectSocket() {
	try {
		if (timer) {
			clearInterval(timer)
			timer = null
		}
		if (stompClient) {
			stompClient.deactivate()
			stompClient = null
			console.log('WebSocket 已断开')
		}
	} catch (e) {
		console.error('断开 socket 连接时出错:', e)
	}
}
